import React, { useCallback } from 'react';
import { TextInputWithAction } from '@/pageTpls/PlatformBuilder/subModules/TagsManagerV2/comps/TextInputWithAction';
import { useCreateTagV3 } from '@/utils/react-query-hooks/tags';

import { addTagToSelection, createTagWithAssociations } from '../utils/tagHelpers';
import { createDuplicateValidator } from '../utils/validators';

export const AddSubThemeTagInput = ({ selectedSubTheme, style, filteredTagsForSelectedSubTheme = [], value, onChange, allTagsGlobal = [] }) => {
  const createTagV3 = useCreateTagV3();

  const validateInput = useCallback(
    createDuplicateValidator({
      sourceList: filteredTagsForSelectedSubTheme,
      requireSubTheme: !selectedSubTheme,
      enforceGlobal: true,
      globalSourceList: allTagsGlobal
    }),
    [filteredTagsForSelectedSubTheme, selectedSubTheme, allTagsGlobal]
  );

  const addToSelection = useCallback((createdTagDoc) => {
    addTagToSelection(createdTagDoc, value, onChange);
  }, [onChange, value]);

  const handleAction = useCallback(async (text) => {
    if (!selectedSubTheme) return;
    const created = await createTagWithAssociations(createTagV3.mutate, {
      display: text,
      subThemeId: selectedSubTheme._id,
    });
    addToSelection(created);
  }, [createTagV3, selectedSubTheme, addToSelection]);

  return (
    <div style={style} onMouseDown={(e) => { e.stopPropagation(); }}>
      <TextInputWithAction
        placeholder={`Add tag to "${selectedSubTheme?.display || 'sub-theme'}"`}
        onAction={handleAction}
        validateInput={validateInput}
        actionButtonIcon={createTagV3.isLoading ? "Loader" : "Plus"}
        disabled={createTagV3.isLoading}
        clearOnAction
      />
    </div>
  );
};


